module.exports = __webpack_public_path__ + "img/272.0b5e58d9.png";